<template>
    <el-dialog title="仓库/仓位选择" :visible.sync="DialogVisible" width="80%" @close="XXX" :close-on-click-modal="false">

        <el-row :gutter="10">
            <el-col span="10">
                <div class="col-body">
                    <el-table highlight-current-row @row-click="warehouseRowClick" :data="responseData"
                        :header-cell-style="{'text-align':'center'}" 
                        :cell-style="{'padding':'0px'}" 
                        border stripe
                        id="XXXX">

                        <el-table-column prop="local_id" label="行" align="center">
                        </el-table-column>

                        <el-table-column prop="number" label="仓库编号" align="center">
                        </el-table-column>

                        <el-table-column prop="name" label="仓库名称" align="center">
                        </el-table-column>

                    </el-table>
                </div>

                <el-pagination style="text-align: center" background layout="prev, pager, next"
                    @current-change="handleCurrentChange" :page-size="pageInfo.size" :current-page="pageInfo.page"
                    :page-count="totalPages">
                </el-pagination>
            </el-col>

            <el-col span="10">
                <div class="col-body">
                    <el-table highlight-current-row @row-click="positionItemsRowClick" :data="m_positionItems"
                        :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}" border stripe
                        id="X">

                        <el-table-column prop="id" label="仓位ID" align="center">
                        </el-table-column>

                        <el-table-column prop="number" label="仓位编号" align="center">
                        </el-table-column>

                        <el-table-column prop="name" label="仓位名称" align="center">
                        </el-table-column>

                    </el-table>
                </div>

            </el-col>

        </el-row>




        <div slot="footer">
            <el-button type="" @click="cancel()">取消</el-button>
            <el-button type="primary" @click="onSubmit()">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/factory/machine/list/add'
    export default {
        data() {
            var lengthruler = (rules, value, cb) => {
                const ruler = /(^[1-9]([0-9]*)$|^[1-9]$)/
                if (ruler.test(value)) {
                    return cb()
                }
                cb(new Error('请输入大于0的正整数'))
            }
            return {
                currentRowIndex: -1,
                DialogVisible: false,
                responseData: [
                    // 调试用假数据--正式版注释掉
                    // {
                    //     number: '测试1',
                    //     name: '测试1',
                    // },
                ],
                m_positionItems: [], //选中的仓位列表

                selectWarehouseId: 1, //当前 选择的 仓库id, 默认选择第一行？
                selectPositionId: 0, //当前 选择的 仓位id

                //已选 仓位
                selectedPosition: {
                    warehouseName: '', //仓库名称
                    
                    positionId: 0, //仓位ID
                    positionName: '', //仓位名称
                    number: '', //仓位编号
                },

                //分页相关--sta
                pageInfo: {
                    page: 1,
                    size: 10,
                },
                totalPages: 0,
                //分页相关--end
            }
        },
        methods: {
            // 外部调用，显示添加机台弹框
            show() {
                this.DialogVisible = true

                //显示对话框 时候 要加载数据
                this.getWarehouseList(1)
            },

            // 外部调用，取 选中的仓库/仓位信息。
            getPositionInfo() {
                return this.selectedPosition
            },

            // 监听回车按钮
            keyCodeListen() {
                // const code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode
                const code = event.keyCode
                if (code === 13) this.onSubmit()
            },
            // 点击 确定 按钮
            onSubmit() {
                if (this.selectPositionId === 0) {
                    this.$Message.closeAll()
                    this.$Message.success('还未选择 或者 仓位表 为空。')
                } else {
                    // console.log("this.selectPositionId=",this.selectPositionId)
                    // console.log("this.m_positionItems=", this.m_positionItems)
                    
                    // console.log("this.selectWarehouseId=", this.selectWarehouseId)
                    // console.log("this.responseData=", this.responseData)
                    this.selectedPosition.warehouseName = this.responseData[this.selectWarehouseId - 1].name //仓库名称

                    this.selectedPosition.positionId = this.m_positionItems[this.selectPositionId - 1].id
                    this.selectedPosition.positionName = this.m_positionItems[this.selectPositionId - 1].name //仓位名称
                    this.selectedPosition.number = this.m_positionItems[this.selectPositionId - 1].number //仓位编号

                    this.$emit('update') //触发 回调的 update函数???
                    this.DialogVisible = false
                }
            },
            // 点击取消按钮触发
            cancel() {
                this.DialogVisible = false
            },
            mounted() {
                document.addEventListener('keyup', this.keyCodeListen)
            },
            destroyed() {
                document.removeEventListener('keyup', this.keyCodeListen)
            },


            // 获取 仓库/仓位 分页列表
            getWarehouseList(val) {
                //---------------------
                this.pageInfo.page = val

                this.$requestBase({
                    url: 'v1/warehouse/list',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
                    this.responseData = this.formatResponse(res.data.list)
                    //初始化仓位列表
                    this.m_positionItems = this.responseData[0].positionItems
                    for (let i = 0; i < this.m_positionItems.length; i++) {
                        this.m_positionItems[i].local_id = i + 1
                    }

                    this.totalPages = res.data.pages
                })
            },
            // 格式化 仓库/仓位 列表
            formatResponse(response) {
                response.forEach((item, index) => {
                    item.local_id = index + 1
                    item.createTime = this.utils.timestampToTime(item.createTime, 2)

                })

                return response
            },

            //"仓库列表" 单击一行
            warehouseRowClick(row, event, column) {
                console.log(row)
                // console.log('row=', row)
                // console.log('event=', event)
                // console.log('column=', column)
                // console.log('row.local_id=', row.local_id)
                this.currentRowIndex=row.local_id
                this.selectWarehouseId = row.local_id

                //更新仓位列表
                this.m_positionItems = this.responseData[this.selectWarehouseId - 1].positionItems
                for (let i = 0; i < this.m_positionItems.length; i++) {
                    this.m_positionItems[i].local_id = i + 1
                }
            },

            //"仓位列表" 单击一行
            positionItemsRowClick(row, event, column) {
                // console.log('row=', row)
                // console.log('event=', event)
                // console.log('column=', column)
                // console.log('row.local_id=', row.local_id)
                this.selectPositionId = row.local_id
            },


            // 分页切换
            handleCurrentChange(newNum) {
                this.getWarehouseList(newNum)
            },

        }
    }
</script>

<style lang="scss" scoped>
    .col-title {
        padding: 5px 0px;
        font-weight: bold;
    }

    .col-body {
        height: 400px;
        border: 1px solid #ccc;
        padding: 0px;
    }
</style>
